// ─── Centralized Property Constants — single source of truth ───────────────

export const PROPERTY_STATUSES = [
  { id: 'Available',       label: 'Available',        color: '#2dce89', bg: '#2dce8920', icon: 'fas fa-check-circle' },
  { id: 'Reserved',        label: 'Reserved',         color: '#fb6340', bg: '#fb634020', icon: 'fas fa-bookmark' },
  { id: 'Negotiation',     label: 'Negotiation',      color: '#ffd600', bg: '#ffd60020', icon: 'fas fa-handshake' },
  { id: 'Sold',            label: 'Sold',             color: '#f5365c', bg: '#f5365c20', icon: 'fas fa-tag' },
  { id: 'Rented',          label: 'Rented',           color: '#11cdef', bg: '#11cdef20', icon: 'fas fa-key' },
  { id: 'Blocked',         label: 'Blocked',          color: '#8898aa', bg: '#8898aa20', icon: 'fas fa-ban' },
  { id: 'MaintenanceHold', label: 'Maintenance Hold', color: '#825ee4', bg: '#825ee420', icon: 'fas fa-tools' },
];

/** Own = your stock; ChannelPartner = external builder inventory you market for commission */
export const INVENTORY_SOURCES = [
  { id: 'Own', label: 'Own inventory', short: 'Own' },
  { id: 'ChannelPartner', label: 'Channel partner (external builder)', short: 'CP' },
];

export const getInventorySource = (id) =>
  INVENTORY_SOURCES.find((x) => x.id === id) ??
  { id, label: id ?? '—', short: id ?? '—' };

export const PROPERTY_CATEGORIES = [
  { id: 'Residential',      label: 'Residential',       icon: 'fas fa-home' },
  { id: 'Commercial',       label: 'Commercial',        icon: 'fas fa-building' },
  { id: 'Plot',             label: 'Plot / Land',       icon: 'fas fa-map' },
  { id: 'Rental',           label: 'Rental',            icon: 'fas fa-key' },
  { id: 'Project',          label: 'Project',           icon: 'fas fa-city' },
  { id: 'BuilderInventory', label: 'Builder Inventory', icon: 'fas fa-hard-hat' },
];

export const SIZE_UNITS = ['SqFt', 'SqM', 'Marla', 'Kanal', 'Acre'];

export const FACING_OPTIONS = ['N', 'S', 'E', 'W', 'NE', 'NW', 'SE', 'SW'];

export const BOOKING_STATUSES = [
  { id: 'Inquiry',   label: 'Inquiry',    color: '#8898aa' },
  { id: 'Token',     label: 'Token Paid', color: '#fb6340' },
  { id: 'Agreement', label: 'Agreement',  color: '#5e72e4' },
  { id: 'Sale',      label: 'Sale Done',  color: '#2dce89' },
  { id: 'Cancelled', label: 'Cancelled',  color: '#f5365c' },
];

export const COMMON_AMENITIES = [
  'Parking', 'Gym', 'Swimming Pool', 'Lift', 'Power Backup',
  'Security', 'Club House', 'Park', 'School Nearby', 'Hospital Nearby',
  'Mall Nearby', 'Metro Nearby', 'Balcony', 'Modular Kitchen', 'Terrace',
];

// ─── Helpers ────────────────────────────────────────────────────────────────
export const getPropertyStatus = (id) =>
  PROPERTY_STATUSES.find((s) => s.id === id) ??
  { id, label: id ?? 'Unknown', color: '#8898aa', bg: '#8898aa20', icon: 'fas fa-question-circle' };

export const getPropertyCategory = (id) =>
  PROPERTY_CATEGORIES.find((c) => c.id === id) ??
  { id, label: id ?? 'Unknown', icon: 'fas fa-building' };

export const getBookingStatus = (id) =>
  BOOKING_STATUSES.find((s) => s.id === id) ??
  { id, label: id ?? 'Unknown', color: '#8898aa' };

export const fmtPrice = (price) => {
  if (!price) return '—';
  const n = Number(price);
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(2)} Cr`;
  if (n >= 100000)   return `₹${(n / 100000).toFixed(2)} L`;
  if (n >= 1000)     return `₹${(n / 1000).toFixed(1)}K`;
  return `₹${n.toLocaleString('en-IN')}`;
};

export const fmtSize = (size, unit = 'SqFt') =>
  size ? `${Number(size).toLocaleString('en-IN')} ${unit}` : '—';

export const parseJson = (str, fallback = []) => {
  try { return JSON.parse(str) || fallback; } catch { return fallback; }
};
